import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Grid, Row, Col, Navbar, Nav, NavItem, Button } from 'react-bootstrap/lib';
import { history } from '../redux/store';

class Header extends Component {
    render() {
        return (
            <header className="hero">
                <Grid>
                    <Row>
                        <Col xs={12} md={6} mdOffset={6}>
                            <Navbar>
                                <Nav className="main-nav">
                                    <NavItem eventKey={1} onClick={() => { history.push('/') }}>Home</NavItem>
                                    <NavItem eventKey={2} href="#">Portfolio</NavItem>
                                    <NavItem eventKey={3} href="#">About</NavItem>
                                    <NavItem eventKey={4} href="#">Contact</NavItem>
                                </Nav>
                            </Navbar>
                            <div className="hero-text">
                                <h1><span>Hi, I am</span><br />Ignacio del Barrio.</h1>
                                <h3>Software Engineer from Argentina</h3>
                                <Button bsStyle="primary" className="btn-lg">Know More</Button>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </header>
        );
    }
}

export default connect()(Header);


// WEBPACK FOOTER //
// ./src/components/Header.js